import React from 'react';
import Img from '../../assets/png/anexe1.png';

interface Props {
  display: string;
}

const Annex = ({ display }: Props) => {
  const DisplayCondition = 'Annex';
  return (
    <div style={{ display: display === DisplayCondition ? 'block' : 'none' }}>
      <div className="text-grey-600 text-center font-bold lg:text-left">
        Prise en charge thérapeutique selon la gravité de l’asthme suivant les recommandations de GINA
      </div>
      <div className="text-grey-600 text-center lg:text-left">(Global Initiative for Asthma; www.ginasthma.org).</div>

      <div className="flex  justify-center mt-8">
        <img src={Img} alt="TherapeuticManagementAlgorithm" title="TherapeuticManagementAlgorithm" />
      </div>
    </div>
  );
};

export default Annex;
